import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import ErrorView from '@/views/Error.vue'
import { t } from '@/i18n'
import HomePage from '@/views/Index.vue'
import beforeEach from './beforeEach'
import afterEach from './afterEach'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: HomePage,
    meta: {
      title: t('home'),
      showBack: false
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
    meta: {
      title: t('home'),
      showBack: false
    }
  },
  {
    // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
    path: '/equipment',
    name: 'deviceManagement',
    component: () => import('@/views/Equipment.vue'),
    meta: {
      title: t('deviceManagement'),
      showBack: false
    }
  },
  // {
  //   // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
  //   path: '/equipment/powerswap/list',
  //   name: 'EquipmentPowerswapList',
  //   meta: {
  //     title: t('powerSwap'),
  //     showBack: false
  //   }
  // },
  // {
  //   // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
  //   path: '/equipment/powercharger/list',
  //   name: 'EquipmentPowerchargerList',
  //   meta: {
  //     title: t('powerCharger'),
  //     showBack: false
  //   }
  // },
  // {
  //   // 此配置仅用于标题变更及其他小部分逻辑，不用于实际页面加载
  //   path: '/equipment/powercharger/group-mgt/list',
  //   name: 'EquipmentPowerchargerGroupMgtList',
  //   meta: {
  //     title: t('powerChargerGroup'),
  //     showBack: false
  //   }
  // },

  {
    path: '/workbench',
    name: 'workbench',
    meta: {
      title: t('workbench'),
      showBack: false
    },
    component: () => import('@/views/workbench/index.vue')
  },
  {
    path: '/error',
    name: 'Error',
    meta: {
      title: 'NPDS',
      showBack: true
    },
    // 主应用error页面不能懒加载，因为直接进入其他子应用error页面→然后created里面跳转（或者
    // beforeEach等任何跳转）到主应用的error页面时，懒加载会导致主应用的error页面显示不了
    component: ErrorView
  },
  {
    path: '/500',
    name: '500',
    meta: {
      title: '500 ERROR!'
    },
    component: () => import('@/views/500.vue')
  }
]

// export default router

export function genRouter() {
  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })

  router.beforeEach(beforeEach)
  router.afterEach(afterEach)

  return router
}
